import { Howl, Howler } from "howler";
import { gsap } from "gsap";

export default class Main {
    constructor() {
        this.sounds = [];
        this.settedTwitter = false;
        this.init();
    }

    init() {
        if (document.querySelector(".single")) {
            this.zoomSwitch();
            this.onmousemove();
            this.soundFunc();
            this.scrollFunc();
            this.characterReady(); //メイン画像のロードを待ってからアニメーションさせる
            this.setTwitter();
        }
    }

    characterReady() {
        const mainimage = document.querySelector(".js-preloadmainimg");

        if (!mainimage) {
            return;
        }

        const img = new Image();
        img.src = mainimage.getAttribute("src");

        img.addEventListener("load", () => {
            document.body.classList.add("-chsingle_ready");
        });
    }

    onmousemove() {
        const charaPh = document.querySelector(".js-chzoom_img .obj");
        const charaElm = document.querySelector(".single__ch__elm .obj");

        if (!charaPh || !charaElm) {
            return;
        }

        if (window.innerWidth >= 835) {
            window.addEventListener("mousemove", (e) => {
                const x_pos = window.innerWidth / 2 - e.clientX;
                const y_pos = window.innerHeight / 2 - e.clientY;

                gsap.to(charaPh, { x: -x_pos / 75, y: -y_pos / 75, duration: 1 });
                gsap.to(charaElm, { x: x_pos / 75, y: y_pos / 75, duration: 1 });
            });
        }
    }

    zoomSwitch() {
        const btn = document.querySelector(".js-chzoom");
        const img = document.querySelector(".js-chzoom_img");

        if (!btn) {
            return;
        }

        btn.addEventListener("click", () => {
            btn.classList.toggle("-zoom");

            if (btn.classList.contains("-zoom")) {
                img.classList.remove("-zoomout");

                setTimeout(() => {
                    img.classList.add("-zoom");
                }, 1);
            } else {
                img.classList.remove("-zoom");

                setTimeout(() => {
                    img.classList.add("-zoomout");
                }, 1);
            }
        });
    }

    soundFunc() {
        const open = document.querySelectorAll(".js-soundplay");

        open.forEach((el) => {
            el.addEventListener("click", () => {
                this.stopSounds();
                open.forEach((el) => el.classList.remove("-active"));

                el.classList.add("-active");

                const voice = new Howl({
                    src: el.getAttribute("data-soundsrc"),
                    onend: () => {
                        el.classList.remove("-active");
                    },
                    onload: () => {
                        voice.play();
                    },
                });

                this.sounds.push(voice);
            });
        });
    }

    stopSounds() {
        this.sounds.forEach((sound) => sound.stop());
        this.sounds = [];
    }

    setTwitter() {
        const container = document.querySelector(".c-twitter_timeline__list");
        const lists = [...container.querySelectorAll(".c-twitter_timeline__list__item")];
        const lists_atag = [...container.querySelectorAll(".c-twitter_timeline__list__item a")];

        lists.forEach((item) => {
            item.addEventListener("click", (e) => {
                window.open(item.getAttribute("data-link"), "_blank");
            });
        });

        lists_atag.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.stopPropagation();
            });
        });
    }

    scrollFunc() {
        // const observeElement = document.querySelector(".js-twcontainer");

        // if (!observeElement) {
        //     return;
        // }

        // //intersection Observerでtwitterが見えたら遅延ロード
        // const options = {
        //     root: null,
        //     threshold: 0,
        // };

        const navoptions = {
            root: null,
            threshold: 0.25,
        };

        // const onIntersect = (entries) => {
        //     // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
        //     entries.forEach((entry) => {
        //         if (entry.isIntersecting) {
        //             this.setTwitter();
        //         }
        //     });
        // };

        // const observer = new IntersectionObserver(onIntersect, options);
        // observer.observe(observeElement);

        const singlenav = document.querySelector(".single__nav");
        const footer = document.querySelector(".l-footer");

        const getOffsetTop = (elm) => {
            const rect = elm.getBoundingClientRect();
            const scrollTop = window.scrollY;
            return rect.top + scrollTop;
        };

        const onNavIntersect = (entries) => {
            // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    //ページの初期状態の考慮
                    let topOffset = 0;

                    if (window.scrollY >= getOffsetTop(footer)) {
                        topOffset = 1000;
                    } else {
                        topOffset = window.scrollY;
                    }

                    singlenav.style.position = "absolute";
                    singlenav.style.top = `${topOffset + Math.round(window.innerHeight / 2) - 35}px`; //ナビの高さも考慮しないとabs時にガクっとなる
                } else {
                    singlenav.style.position = "fixed";
                    singlenav.style.top = "50%";
                }
            });
        };

        if (window.innerWidth >= 835) {
            const navobserver = new IntersectionObserver(onNavIntersect, navoptions);
            navobserver.observe(footer);
        }
    }
}
